import { Backdrop, CircularProgress } from "@mui/material";
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { HashRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import ThemeInitializer from "./components/theme/ThemeInitializer";
import { AuthProvider } from './config/AuthProvider/authProvider';
import { EXTERNAL_PROVIDE_TOKEN } from './config/cacheKey';
import { useInitialTheme } from "./hooks/useInitialTheme";
import PWASplash from './layouts/_core/pwaSplash';
import { IShellConfig } from './models/IShellConfig';
import BasePage from './routes/basePage';
import { getTokenClaims, setJwtToken } from './services/auth.service';
import setupAxiosInterceptors from './services/interceptors';
import { useDispatch } from "react-redux";
import { setupTheme } from "./redux/theme/themeSlice";
import Adtrace from "web-adtrace"
function App() {
   //  const prefer = useMediaQuery('(prefers-color-scheme:light)');
   // const [mode, setMode] = useState();
   const [jsonFile, setJsonFile] = useState<IShellConfig>();
   // const mode = useInitialTheme();
   const mode = 'light';
   const dispatch = useDispatch();
   dispatch(
      setupTheme(mode)
   )
   const darkTheme = createTheme({
      typography: {
         fontSize: 14,
      },
      // palette: {
      //    mode: mode ? 'dark' : 'light',
      // },
   });
   useEffect(() => {

      fetch('/setting/shellConfig.json')
         .then((response) => response.json())
         .then((data) => {
            setJsonFile(data);
         });
      Adtrace.initSdk({
         appToken: process.env.REACT_APP_ADTRACE_APP_TOKEN || '',
         environment: process.env.REACT_APP_ENV === 'prod' ? 'production' : 'sandbox',
      });

   }, []);

   const themeColors = jsonFile?.[mode];

   const css = `
    .primaryColorLight{
       color:${themeColors?.primaryColorLight}
    }
    .bgPrimaryColorLight{
       background-color:${themeColors?.primaryColorLight}
    }
   .primaryColorLight-900{
       color:${themeColors?.primaryColorLight900}
    }
   .bgPrimaryColorLight-900{
       background-color:${themeColors?.primaryColorLight900}
    }
   .primaryColorLight-100{
       color:${themeColors?.primaryColorLight100}
    }
    .bgPrimaryColorLight-100{
       background-color:${themeColors?.primaryColorLight100}
    }
   .primaryColorLight-200{
       color:${themeColors?.primaryColorLight200}
    }
    .bgPrimaryColorLight-200{
       background-color:${themeColors?.primaryColorLight200}
    }
   .primaryColorLight-300{
       color:${themeColors?.primaryColorLight300}
    }
   .borderColorPrimaryColorLight-300{
      border-color:${themeColors?.primaryColorLight300} !important
   }
    .bgPrimaryColorLight-300{
       background-color:${themeColors?.primaryColorLight300}
    }
   .primaryColorLight-400{
       color:${themeColors?.primaryColorLight400}
    }
    .bgPrimaryColorLight-400{
       background-color:${themeColors?.primaryColorLight400}
    }
   .primaryColorLight-500{
       color:${themeColors?.primaryColorLight500}
    }
    .bgPrimaryColorLight-500{
       background-color:${themeColors?.primaryColorLight500}
    }
    .secondaryColorLight{
       color:${themeColors?.secondaryColorLight}
    }
    .bgSecondaryColorLight{
       background-color:${themeColors?.secondaryColorLight}
    }
    .secondaryColorLight-500{
       color:${themeColors?.secondaryColorLight500}
    }
    .bgSecondaryColorLight-500{
       background-color:${themeColors?.secondaryColorLight500}
    }
    .secondaryColorLight-600{
       color:${themeColors?.secondaryColorLight600}
    }
    .bgSecondaryColorLight-600{
       background-color:${themeColors?.secondaryColorLight600}
    }
    .borderColorSecondaryColorLight-600{
      border-color:${themeColors?.secondaryColorLight600} !important
   }
    .secondaryColorLight-100{
       color:${themeColors?.secondaryColorLight100}
    }
    .bgSecondaryColorLight-100{
       background-color:${themeColors?.secondaryColorLight100}
    }
    .primaryColorDark{
       color:${themeColors?.primaryColorDark}
    }
    .bgPrimaryColorDark{
       background-color:${themeColors?.primaryColorDark}
    }
    .secondaryColorDark{
       color:${themeColors?.secondaryColorDark}
    }
    .bgSecondaryColorDark{
       background-color:${themeColors?.secondaryColorDark}
    }
    .primaryErrorColorLight{
       color:${themeColors?.primaryErrorColorLight}
    }
    .bgPrimaryErrorColorLight{
       background-color:${themeColors?.primaryErrorColorLight}
    }
    .borderColorPrimaryErrorColorLight{
      border-color:${themeColors?.primaryErrorColorLight} !important
   }
    .secondaryErrorColorLight{
       color:${themeColors?.secondaryErrorColorLight}
    }
    .bgSecondaryErrorColorLight{
       background-color:${themeColors?.secondaryErrorColorLight}
    }
    .disableColorLihgt{
       color:${themeColors?.disableColorLihgt}
    }
    .bgDisableColorLihgt{
       background-color:${themeColors?.disableColorLihgt}
    }
       .bgButtonColor{
       background-color:${themeColors?.bgButtonColor}}
    .cardDesign{
       color:${themeColors?.primaryColorLight900};
       background-color:var(--input-bg-color);
       border-radius: 5px;
    }
    .errorCardDesign{
       color:${themeColors?.primaryColorLight900};
       background-color:${themeColors?.secondaryErrorColorLight};
      //  border:1px solid ${themeColors?.primaryColorLight300};
       border-radius: 5px;
    }
    .cardBorderDesign{
       border:1px solid ${themeColors?.primaryColorLight300};
       max-height:fit-content ;
    }
    .rejectCardBorderDesign {
       border: 1px solid ${themeColors?.primaryErrorColorLight};
       max-height: fit-content;
    }
    .acceptCardBorderDesign {
       border: 1px solid ${themeColors?.secondaryColorLight600};
       max-height: fit-content;
    }
    .rmc-picker-item > div {
     color:${themeColors?.primaryColorLight900}
    }
    .imageUpload{
      border:dashed 2px #BBA57A;
      background:${themeColors?.primaryColorLight500};
      border-radius: 5px;
      height:100%;
      min-width: 100%;
      text-align: center;
      margin: auto;
      display:  inline-block;
    }
      .textFieldBorderDesign{
      //  border:1px solid ${themeColors?.primaryColorLight300};
       border-radius:5px;
       background-color:var(--input-bg-color) !important;
      }
       .witheColor{
       color:#fff !important
       }
       .border300{
       border:1px solid ${themeColors?.primaryColorLight300};
    }
}
    `;
   useEffect(() => {
      // add for message timeout token plz test
      if (getTokenClaims() && getTokenClaims()!.exp!) {
         const milliseconds = new Date().getTime();
         const seconds = Math.floor(milliseconds / 1000);
         const timeToken = Number(getTokenClaims()!.exp)
         if (timeToken < seconds) {
            localStorage.removeItem(EXTERNAL_PROVIDE_TOKEN);
            setJwtToken('', '');
         }
      }
      setupAxiosInterceptors(axios);
   }, [])

   return (
      <>
         <ThemeInitializer themeMode={mode} />
         <Container
            fixed
            className="containerApp"
            sx={{
               '@media (min-width: 550px)': {
                  // borderRadius: '30px',
                  height: '100svh',
                  overflowY: 'auto',
                  maxWidth: '550px !important',
               },
            }}
         >
            <style>{css}</style>
            <ToastContainer
               rtl={true}
               closeButton={false}
               pauseOnHover={true}
               position={'top-center'}
               newestOnTop={true}
               limit={3}
               theme={mode}
            />
            {/*///////////////////////////// for future dark and light mode */}
            {/* {!mode ? (
                   <DarkModeIcon
                       onClick={() => {
                           setMode(true);
                       }}
                       sx={{marginTop: '30px'}}
                   />
               ) : (
                   <LightModeIcon
                       onClick={() => {
                           setMode(false);
                       }}
                       sx={{marginTop: '30px'}}
                   />
               )} */}
            <Backdrop
               hidden={true}
               sx={{
                  color: "#fff", zIndex: () => 10000
               }}
               open={true}
            >
               <div
                  style={{
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     height: '100%',
                  }}
               >
                  <CircularProgress sx={{ color: "#BBA57A" }} />
               </div>
            </Backdrop>
            <ThemeProvider theme={darkTheme}>
               <AuthProvider>
                  <CssBaseline />
                  <HashRouter>
                     <PWASplash>
                        <BasePage />
                     </PWASplash>
                  </HashRouter>
               </AuthProvider>
            </ThemeProvider>
         </Container>
      </>
   );

}

export default App;
